function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "bg-path",
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "real-path",
  d: "M2340 4839 c-891 -98 -1643 -704 -1920 -1549 -135 -411 -147 -882   -34 -1299 154 -567 523 -1051 1032 -1356 778 -466 1783 -412 2512 135 478 358   793 887 886 1490 25 158 25 491 1 648 -117 750 -575 1380 -1242 1707 -220 108   -395 164 -640 206 -139 23 -459 33 -595 18z m1465 -1799 l320 -320 -1553 0   -1552 0 0 125 0 125 1246 2 1246 3 -101 100 c-56 55 -101 104 -101 110 0 10   160 175 170 175 3 0 149 -144 325 -320z m315 -840 l0 -130 -1242 0 -1243 0   105 -105 105 -105 -90 -90 -90 -90 -317 317 c-175 175 -318 321 -318 325 0 5   695 8 1545 8 l1545 0 0 -130z"
}));

function SvgIconSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwap);
export default __webpack_public_path__ + "static/media/icon-swap.5f2d75a7.svg";
export { ForwardRef as ReactComponent };